import { NextRouter } from 'next/router';

export const isActiveLink = (currentRouter: NextRouter, activeStyle: string, currentPath = '', itemId = '') => {
  if (itemId === 'new-event-wizard') {
    return '';
  }

  if (itemId === 'reporting') {
    return currentRouter.asPath.startsWith('/reporting') ? activeStyle : '';
  }

  const decodePaths = window.decodeURIComponent(currentRouter.asPath).split('/');
  const paths = currentPath.split('/');

  if (paths.length > decodePaths.length) return '';
  for (let index = 1; index < paths.length; index += 1) {
    if (decodePaths[index] !== paths[index]) return '';
  }

  return activeStyle;
};
